import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4281f9b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-cy"]
const _hoisted_2 = ["src"]

import { getDefaultBackgroundColor } from "@/utils/utilities";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'globalAvatar',
  props: {
    src: {},
    name: {},
    className: {},
    fontSize: {},
    fontWeight: {},
    isRectangle: { type: Boolean },
    imgClassName: {},
    dataCy: {}
  },
  setup(__props: any) {

const props = __props;



const avatarBgColor = computed(() => {
  if (props.src) {
    return "unset";
  }
  return getDefaultBackgroundColor(props.name || "");
});

const letterName = computed(() => {
  const arr = `${props.name?.trim() || ""}`.split(" ").filter(Boolean);
  if (arr.length === 0) return "";

  if (props.isRectangle) {
    return `${arr[0]?.[0] || ""}${arr.length > 1 ? arr[1]?.[0] || "" : ""}`;
  }

  return `${arr[0]?.[0] || ""}${
    arr.length > 1 ? arr[1]?.[0] || arr[0]?.[1] || "" : arr[0]?.[1] || ""
  }`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "menu-global-avatar",
    "data-cy": _ctx.dataCy,
    class: _normalizeClass(`global-avatar ${_ctx.className || ''} ${
      _ctx.isRectangle && !!_ctx.src
        ? '!tw-rounded-none'
        : _ctx.isRectangle && !_ctx.src
          ? '!tw-w-[39px]'
          : ''
    }`),
    style: _normalizeStyle(`background-color: ${avatarBgColor.value}`)
  }, [
    (!!_ctx.src)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          alt: "avatar",
          src: _ctx.src,
          class: _normalizeClass(`${_ctx.imgClassName} ${_ctx.isRectangle ? '!tw-rounded-none' : ''}`)
        }, null, 10, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          style: _normalizeStyle(`font-size:${_ctx.fontSize}; font-weight: ${_ctx.fontWeight}`)
        }, _toDisplayString(letterName.value.toUpperCase()), 5))
  ], 14, _hoisted_1))
}
}

})